import React from 'react';

import { Box, ButtonGroup } from '@mui/material';

import { FORM_FIELD_TYPES, FormField } from '../../../../../components/form/form-field';
import SaveButton from '../../../../../components/form/save-button';

const DeleteFileTaskForm = ({ form, onSubmit, onChange }) => {
  const { errors } = form.formState;
  const formControl = form.control;

  return (
    <Box
      component="form"
      onSubmit={form.handleSubmit(onSubmit)}
      onReset={form.reset}
      onChange={onChange}
    >
      <FormField
        controlId="deleteFileTaskFormName"
        label="name"
        name="name"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter name"
        required
        error={errors.name?.message}
      />
      <FormField
        controlId="deleteFileTaskFormType"
        label="type"
        name="type"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        disabled
        error={errors.type?.message}
      />
      <FormField
        controlId="deleteFileTaskFormFunction"
        label="function"
        name="function"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        disabled
        error={errors.function?.message}
        defaultValue="deleteFile"
      />
      <FormField
        controlId="deleteFileTaskFormCredentials"
        label="credentials"
        name="parameters.credentials"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter credentials"
        error={errors.parameters?.credentials?.message}
      />
      <FormField
        controlId="deleteFileTaskFormPort"
        label="port"
        name="parameters.port"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter port"
        error={errors.parameters?.port?.message}
      />
      <FormField
        controlId="deleteFileTaskFormTarget"
        label="target"
        name="parameters.target"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter target path"
        required
        error={errors.parameters?.target?.message}
      />
      <FormField
        controlId="deleteFileTaskFormResult"
        label="result"
        name="parameters.result"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter result"
        required
        error={errors.parameters?.result?.message}
      />
      <ButtonGroup>
        <SaveButton />
      </ButtonGroup>
    </Box>
  );
};

export default DeleteFileTaskForm;
